// eslint-disable-next-line
// @ts-nocheck
import { useState } from 'react';
// material
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import { vendorFlagging as vendorFlaggings } from '../../_mock/bookings';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'parkingSpaceName', label: 'Parking Space Name', alignRight: false },
  { id: 'active', label: 'Active', alignRight: false },
  { id: 'suspend', label: 'Suspend', alignRight: false },
  { id: 'retention', label: 'Retention', alignRight: false },
  { id: 'dead', label: 'Dead', alignRight: false },
  { id: 'closing', label: 'Closing', alignRight: false },
  { id: 'edit', label: 'Edit', alignRight: false },
  { id: 'deleted', label: 'Delete', alignRight: false },
  { id: '' },
];

export default function VendorFlagging() {
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [vendorFlaggingData, setVendorFlaggingData] = useState(vendorFlaggings);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [name, setName] = useState('');
  const filteredUsers = vendorFlaggingData;
  const isUserNotFound = filteredUsers.length === 0;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Vendor Flagging">
      <Container>
        <Typography variant="h4" gutterBottom>
          Vendor Flagging
        </Typography>
        <Card>
          <BookingListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={vendorFlaggingData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, parkingSpaceName, active, suspend, retention, dead, closing, edit, deleted } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {parkingSpaceName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Switch checked={active} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={suspend} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={retention} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={dead} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={closing} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={edit} />
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2"></Typography>
                            <Switch checked={deleted} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={vendorFlaggingData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {vendorFlaggingData.isLoading ? (
          // || deleteResponse.isLoading
          <Loading />
        ) : null}
      </Container>
    </Page>
  );
}
